var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"font--m-3 rounded-4",attrs:{"block":"","color":"accent","large":"","depressed":"","height":"52","disabled":_vm.loading,"loading":_vm.loading},on:{"click":_vm.deleteRequest}},[_vm._v(" 신청 취소하기 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }